export class ChangePasswordWithTokenDto {

  constructor(public user: string, public pass: string, public oldpass: string, public token: string) { }
}
